(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dose-time"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // 保证jquery 异步加载完成
    let jqueryInterval = setInterval(function () {
      if (typeof jQuery !== 'undefined') {
        clearInterval(jqueryInterval);
        jquery_init();
      }
    }, 300);
    function jquery_init() {
      $(function () {
        // Tab 切换
        $('.dose-time__tab-btn').on('click', function () {
          const tab = $(this).data('tab');
          $('.dose-time__tab-btn').removeClass('active');
          $(this).addClass('active');
          $('.dose-time__content').removeClass('active');
          $('#dt-tab-' + tab).addClass('active');
        });

        // 计算 Time
        $('.dt-calc-time').on('click', function () {
          let irradiance = parseFloat($('.dt-irradiance').val());
          let dose = parseFloat($('.dt-dose').val());
          if (isNaN(irradiance) || isNaN(dose) || irradiance <= 0 || dose <= 0) {
            alert('Please input valid positive numbers!');
            return;
          }
          console.log('dose', dose);
          console.log('irradiance', irradiance);
          let time = (dose * 1000) / irradiance / 60;
          $('.dt-result-time-val').text(time.toFixed(2) + ' min');
          $('#dt-result-time').show();
        });

        // 重置 Time
        $('.dt-reset-time').on('click', function () {
          $('.dt-irradiance, .dt-dose').val('');
          $('#dt-result-time').hide();
          $('.dt-result-time-val').text('--');
        });

        // 计算 Dose
        $('.dt-calc-dose').on('click', function () {
          let irradiance = parseFloat($('.dt-irradiance-dose').val());
          let time = parseFloat($('.dt-time-dose').val());
          if (isNaN(irradiance) || isNaN(time) || irradiance <= 0 || time <= 0) {
            alert('Please input valid positive numbers!');
            return;
          }
          let dose = (irradiance * 60 * time) / 1000;
          $('.dt-result-dose-val').text(dose.toFixed(2) + ' J/cm²');
          $('#dt-result-dose').show();
        });

        // 重置 Dose
        $('.dt-reset-dose').on('click', function () {
          $('.dt-irradiance-dose, .dt-time-dose').val('');
          $('#dt-result-dose').hide();
          $('.dt-result-dose-val').text('--');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
